import { Icon, Typography } from '@frontend-workspace/react-shared-lib';

export interface FileDropzoneProps {
  getRootProps: () => any;
  getInputProps: () => any;
  isDragActive: boolean;
  label: string;
  hint: string;
}

/**
 * The drag-and-drop box only -- the caller owns its own useDropzone call
 * (accept types, multiple, size limits all vary per use) and passes its
 * result straight through as props.
 */
export function FileDropzone(props: FileDropzoneProps) {
  return (
    <div
      {...props.getRootProps()}
      className="d-flex flex-column align-items-center justify-content-center mb-3"
      style={{
        border: '2px dashed',
        borderColor: props.isDragActive ? '#1976d2' : '#bdbdbd',
        borderRadius: '4px',
        padding: '24px',
        cursor: 'pointer',
        backgroundColor: props.isDragActive ? 'rgba(0,0,0,0.04)' : 'transparent'
      }}
    >
      <input {...props.getInputProps()} />
      <Icon className="material-icons-outlined" fontSize="large">upload_file</Icon>
      <Typography variant="body1"><b>{props.label}</b></Typography>
      <Typography variant="body2">{props.hint}</Typography>
    </div>
  );
}

export default FileDropzone;
